import { validateStringEnum } from "../../../packages/validator/validator.js";

/**
 * Supported currencies of the system.
 */
export type Currency = "eur" | "usd" | "gbp";

export const validateCurrency = validateStringEnum(["eur", "usd", "gbp"]);
